import { ladderAccess, levelSomewhere, servicesHome } from '@church/data'
import { atLeast } from '@church/permissions'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { SeriesPlannerPage } from '../components/services/Sermons.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'

/**
 * Sermons › Plan a series: outlines from a book or a topic, made into a
 * series and its draft plans when someone chooses (docs/15). Editor on a
 * service type.
 */
export const Route = createFileRoute('/_authed/_shell/services/_sections/sermons/planner')({
  beforeLoad: ({ context }) => {
    const held = ladderAccess(context.me)
    if (!atLeast(levelSomewhere(held, 'planning'), 'editor'))
      throw redirect({ to: servicesHome(held), replace: true })
  },
  component: PlannerScreen,
})

function PlannerScreen() {
  useBreadcrumbs([{ label: 'Sermons', href: '/services/sermons' }, { label: 'Plan a series' }])
  return <SeriesPlannerPage />
}
